import React, { Fragment, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Menu, Transition } from '@headlessui/react'
import { MenuAlt1Icon } from '@heroicons/react/outline'
import { ChevronDownIcon } from '@heroicons/react/solid'
import HttpService from '../services/HttpService'
import UserService from '../services/UserService'
import { ConfigAccessButton, ConfigAccessProvider } from './ConfigAccess'
import { classNames } from './ui'

const Header = ({ titulo, onMenu }) => {
    const profile = UserService.getProfile()
    const displayName = profile.displayName || profile.email || 'Usuario'
    const [empresa, setEmpresa] = useState({ codigoEmpresa: profile.company, nombre: '' })

    useEffect(() => {
        HttpService.getAxiosClient().get('/empresa').then((res) => {
            setEmpresa({
                codigoEmpresa: res.data?.codigoEmpresa || '',
                nombre: res.data?.nombre || '',
            })
        }).catch(() => {})
    }, [])

    const initials = (
        (profile.givenName?.[0] || '') + (profile.familyName?.[0] || '')
        || displayName.slice(0, 2)
    ).toUpperCase()

    return (
        <ConfigAccessProvider>
        <header className="sticky top-0 z-30 flex min-h-16 items-center justify-between border-b border-slate-200 bg-white/90 px-4 py-2 backdrop-blur sm:px-6 lg:px-8">
            <div className="flex items-center gap-3">
                <button
                    type="button"
                    className="rounded-lg p-2 text-slate-500 hover:bg-slate-100 lg:hidden"
                    onClick={onMenu}
                >
                    <MenuAlt1Icon className="h-6 w-6" />
                </button>
                <div>
                    <h1 className="text-lg font-semibold leading-tight text-slate-900">{titulo}</h1>
                </div>
            </div>

            <Menu as="div" className="relative">
                <Menu.Button className="flex items-center gap-3 rounded-xl py-1.5 pl-1.5 pr-2 hover:bg-slate-50">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-600 text-xs font-semibold text-white">
                        {initials}
                    </span>
                    <span className="hidden text-left sm:block">
                        <span className="block max-w-[200px] truncate text-sm font-medium text-slate-900">{displayName}</span>
                        {empresa.codigoEmpresa && (
                            <span className="block max-w-[200px] truncate font-mono text-xs text-slate-500">{empresa.codigoEmpresa}</span>
                        )}
                        {empresa.nombre && (
                            <span className="block max-w-[200px] truncate text-xs text-slate-500">{empresa.nombre}</span>
                        )}
                    </span>
                    <ChevronDownIcon className="h-4 w-4 text-slate-400" />
                </Menu.Button>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right rounded-xl bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-none">
                        <Menu.Item>
                            {({ active }) => (
                                <Link
                                    to="/perfil"
                                    className={classNames(active ? 'bg-slate-50' : '', 'block px-4 py-2 text-sm text-slate-700')}
                                >
                                    Mi perfil
                                </Link>
                            )}
                        </Menu.Item>
                        {UserService.hasRole(['admin']) && (
                        <Menu.Item>
                            {({ active }) => (
                                <ConfigAccessButton
                                    className={classNames(active ? 'bg-slate-50' : '', 'block w-full px-4 py-2 text-left text-sm text-slate-700')}
                                >
                                    Configuración
                                </ConfigAccessButton>
                            )}
                        </Menu.Item>
                        )}
                        <div className="my-1 border-t border-slate-100" />
                        <Menu.Item>
                            {({ active }) => (
                                <button
                                    type="button"
                                    onClick={() => {
                                        window.history.replaceState('', '', '/')
                                        UserService.doLogout()
                                    }}
                                    className={classNames(active ? 'bg-slate-50' : '', 'block w-full px-4 py-2 text-left text-sm text-rose-600')}
                                >
                                    Cerrar sesión
                                </button>
                            )}
                        </Menu.Item>
                    </Menu.Items>
                </Transition>
            </Menu>
        </header>
        </ConfigAccessProvider>
    )
}

export default Header
